function plotTypes () {
	return [
		type('bar', 'charts.chart.plotType.bar', ['bar', 'line', 'area']),
		type('line', 'charts.chart.plotType.line', ['bar', 'line', 'area']),
		type('area', 'charts.chart.plotType.area', ['bar', 'line', 'area']),
		type('combination', 'charts.chart.plotType.combination', ['bar', 'line', 'area']),
		type('pie', 'charts.chart.plotType.pie'),
		type('donut', 'charts.chart.plotType.donut'),
		type('polar', 'charts.chart.polarChart'),
		type('filled-map', 'charts.filledRegion'),
		type('bubble-map', 'charts.bubble', ['filled-map', 'bubble-map', 'spike-map']),
		type('spike-map', 'charts.spike', ['filled-map', 'bubble-map', 'spike-map']),
		type('waffle', 'charts.chart.plotType.waffle'),
		type('filled-container', 'charts.chart.plotType.filledContainer'),
		type('timeline', 'charts.chart.plotType.timeline'),
		type('funnel', 'charts.chart.plotType.funnel'),
		type('cycle', 'charts.chart.plotType.cycle'),
		type('process', 'charts.chart.plotType.process'),
		type('pyramid', 'charts.chart.plotType.pyramid'),
		type('tree-map', 'charts.chart.plotType.treeMap')
	]
}

/**
 * @param canAdd a list of plot types that can be added to a chart set to this type
 *        by default, this is restricted to only the set plot type
 */
function type (type, label, canAdd = [type]) {
	return {
		type,
		label,
		icon: type,
		canAdd
	}
}

export default plotTypes

plotTypes.__filename__ = 'charts/edit/serie/plot-types.js'
